import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { decryptText } from '../../utils/utils';
import { LoginResponse } from '../../utils/dto/response/auth';
import Cookies from "js-cookie";

const auth = JSON.parse(decryptText(Cookies.get("__auth_session")) || '{}');
const initialState: LoginResponse = {
	session_expires: auth.session_expires || null,
	token: auth.token || null,
	userDetails: auth.userDetails || null,
};

const authUserSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthUser: (state, action: PayloadAction<LoginResponse>) => {
			return { ...state, ...action.payload };
		},
		deleteAuthUser: () => ({
			session_expires: null,
			token: null,
			userDetails: null,
		}),
	},
});

export const { setAuthUser, deleteAuthUser } = authUserSlice.actions;
export default authUserSlice.reducer;
